import { Icon } from '@iconify/react';
import { Box, Grid, IconButton } from '@mui/material';
import { Breadcrumbs } from 'components/breadcrumbs/Breadcrumbs';
import { PageHeader } from 'components/page-header/PageHeader';
import { sharedStyles } from 'lib';
import React, { CSSProperties } from 'react';
import { paperWrapperStyles } from './page-wrapper-helper';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Chip } from '@biq/apex-ui';
interface PageWrapperProps {
    title?: string;
    subTitle?: string;
    tagline?: string;
    includeBreadcrumbs?: boolean;
    includeAddButton?: boolean;
    onIncludeButtonClick?: Function;
    children?: React.ReactNode;
    breadCrumStatus?: string;
    breadCrumType?: string;
    breadCrumData?: string;
    customHeight?: boolean;
    readOnly?: boolean;
    onBackArrowClick?: Function;
    includeStatusChip?: boolean;
    chipColor?:
        | 'primary'
        | 'default'
        | 'secondary'
        | 'error'
        | 'info'
        | 'success'
        | 'warning'
        | 'grayscale';
    chipSize?: 'small' | 'medium';
    chipLabel?: string;
    childrenContainerStyles?: CSSProperties;
}

export const PageWrapper = (props: PageWrapperProps): React.JSX.Element => {
    const {
        title,
        subTitle,
        tagline,
        includeAddButton,
        children,
        onIncludeButtonClick,
        includeBreadcrumbs,
        breadCrumStatus,
        breadCrumType,
        breadCrumData,
        customHeight,
        readOnly = false,
        onBackArrowClick,
        includeStatusChip = false,
        chipColor = 'primary',
        chipSize,
        chipLabel,
        childrenContainerStyles,
    } = props;

    const handleAddClick = (): void => {
        if (onIncludeButtonClick) {
            onIncludeButtonClick();
        }
    };

    const handleBackArrowClick = (): void => {
        if (onBackArrowClick) {
            onBackArrowClick();
        }
    };

    return (
        <>
            <Box sx={paperWrapperStyles.main}>
                <Box
                    sx={{
                        ...paperWrapperStyles.headerBox,
                        ...(!includeStatusChip &&
                            !includeAddButton &&
                            paperWrapperStyles.headerBoxContainerStyles),
                    }}
                >
                    {readOnly ? (
                        <Box
                            sx={paperWrapperStyles.backArrowIconContainerStyles}
                            onClick={handleBackArrowClick}
                        >
                            <ArrowBackIcon
                                sx={paperWrapperStyles.backArrowIconStyles}
                            />
                        </Box>
                    ) : null}
                    <PageHeader
                        title={title ?? ''}
                        subTitle={subTitle}
                        tagline={tagline}
                    />
                    {includeStatusChip ? (
                        <Grid sx={paperWrapperStyles.chipContainerStyles}>
                            <Chip
                                color={chipColor}
                                size={chipSize}
                                label={chipLabel}
                                readOnly
                            />
                        </Grid>
                    ) : null}
                    {includeAddButton ? (
                        <IconButton
                            color='primary'
                            sx={sharedStyles.plusIcon}
                            onClick={handleAddClick}
                        >
                            <Icon
                                icon='mdi:plus'
                                style={paperWrapperStyles.icon}
                            />
                        </IconButton>
                    ) : (
                        <></>
                    )}
                </Box>
                {includeBreadcrumbs ? (
                    <Breadcrumbs
                        status={breadCrumStatus}
                        breadCrumType={breadCrumType}
                        breadCrumData={breadCrumData}
                    />
                ) : (
                    <></>
                )}
            </Box>
            <Box
                sx={{
                    ...paperWrapperStyles.childContainer,
                    ...(customHeight && paperWrapperStyles.customHeight),
                    ...childrenContainerStyles,
                }}
            >
                {children}
            </Box>
        </>
    );
};
